import React, { Fragment, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XIcon } from "@heroicons/react/outline";
import { PanelLeft } from "lucide-react";
import logo from "../../../resources/images/logo-white.svg";
import SidebarMenu from "./sidebar-menu";

import CompanySwitch from "./company-switch";
import { useLocation } from "react-router-dom";
import Notification from "../header/notification";
import { classNames } from "../../../utils/Utils";

function Sidebar({ sidebarOpen, setSidebarOpen, isHidden, setHidden }) {
  const { pathname } = useLocation();

  useEffect(() => {
    setSidebarOpen(false);
    // eslint-disable-next-line
  }, [pathname]);

  return (
    <>
      <Transition.Root show={sidebarOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 flex z-50 md:hidden"
          onClose={setSidebarOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-600 bg-opacity-75" />
          </Transition.Child>
          <Transition.Child
            as={Fragment}
            enter="transition ease-in-out duration-300 transform"
            enterFrom="-translate-x-full"
            enterTo="translate-x-0"
            leave="transition ease-in-out duration-300 transform"
            leaveFrom="translate-x-0"
            leaveTo="-translate-x-full"
          >
            <div className="relative flex-1 flex flex-col max-w-xs w-full pt-5 bg-blue-1000">
              <Transition.Child
                as={Fragment}
                enter="ease-in-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in-out duration-300"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="absolute top-0 right-0 -mr-12 pt-2">
                  <button
                    type="button"
                    className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                    onClick={() => setSidebarOpen(false)}
                  >
                    <span className="sr-only">Close sidebar</span>
                    <XIcon className="h-6 w-6 text-white" aria-hidden="true" />
                  </button>
                </div>
              </Transition.Child>
              <div className="flex-shrink-0 flex items-center px-4">
                <img className="h-10 w-auto" src={logo} alt="Workflow" />

              </div>
              <div className="mt-5 flex-1 h-0 overflow-y-auto">
                <nav>
                  <SidebarMenu />
                </nav>
              </div>
              <CompanySwitch />
            </div>
          </Transition.Child>
          <div className="flex-shrink-0 w-14" aria-hidden="true">
            {/* Dummy element to force sidebar to shrink to fit close icon */}
          </div>
        </Dialog>
      </Transition.Root>

      {/* Static sidebar for desktop */}
      <div
        className={classNames(
          "hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0 z-20 transform transition-transform duration-300 ease-in-out",
          isHidden ? "-translate-x-full opacity-0 pointer-events-none" : "translate-x-0 opacity-100"
        )}
      >
        <div className="flex flex-col flex-grow pt-5 bg-blue-1000 overflow-y-auto">
          <div className="flex items-center justify-between px-4">
            <img className="h-9 w-auto" src={logo} alt="Dokless" />
            <div className="flex items-center space-x-3">
              <Notification />
              <button
                type="button"
                onClick={() => setHidden(true)}
                className="hidden md:inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-blue-1000"
                title="Nascondi sidebar"
              >
                <PanelLeft className="h-5 w-5" />
              </button>
            </div>
          </div>

          <div className="mt-5 flex-1 flex flex-col">
            <nav className="flex-1 pb-4">
              <SidebarMenu />
            </nav>
          </div>

          <CompanySwitch />
        </div>
      </div>
    </>
  );
}

export default Sidebar;
